<template>
	<div  id="pg5" >  
		<section  class="membresia">
<!--			<img v-responsive.xl.lg src="@/assets/landing/empleador/membresia/contrata membresia 1680x1050.jpg"-->
			<img v-responsive.xl.lg src="@/assets/landing/empleador/membresia/contrata-membresia-1680x1050.jpg"
				 class="section_img">
			<img v-responsive.md src="@/assets/landing/empleador/membresia/contrata membresia 1024x768.jpg"
				 class="section_img">
			<img v-responsive.xs.sm src="@/assets/landing/empleador/membresia/contrata membresia 768x1024.jpg"
				 class="section_img">

			<div class="hyper-link"> 
				<div :class="isMobile ? 'row justify-content-center' : ''" >
					<a href="/memberships"  :class="isMobile ? 'btn b-orange w-50 float-center' :  'btn b-orange w-50 float-right'" v-if="isLogin">
						¡Comienza Ya!
					</a>
					<a href="/registrar/empresa"  :class="isMobile ? 'btn b-orange w-50 float-center' :  'btn b-orange w-50 float-right'" v-else>
						¡Comienza Ya!
					</a>
				</div>
			</div>
		</section>

	</div>
</template>

<script>
export default {
	name: "membresia",
	props:['isLogin'],
		data() {
		return {
			isMobile: this.$mobile(),
		}
	}
}
</script>

<style scoped lang="scss">
.section_img {
	width: 100%;
	z-index: 1;
}
.membresia{
	position:relative;
}
.membresia .hyper-link a{
	font-size: large;
}
.membresia .hyper-link{
	position: absolute;
	bottom: 15%;
	right: 31%;
	width: 25%;

	@media only screen and (max-width: 450px) {
		bottom: 15%;
		left: 12%;
		width: 50%;
	}
	@media only screen and (min-width: 320px) and (max-device-width: 581px) {
		top: 71%;
		left: 4%;
		width: 90%;
	}
	@media only screen and (min-width: 768px) {
		bottom: 25%;
		right: 10%;
		width: 45%;
	}
	@media only screen and (min-width: 960px) {
		bottom: 25%;
		right: 15%;
	}
	@media only screen and (min-width: 1440px) {
		bottom: 35%;
		right: 16%;
		width: 25%;
	}
	@media only screen and (min-width: 2000px) {
		bottom: 15%;
		right: 21%;
	}
	@media only screen and (max-device-width: 480px) {
		bottom: 4%;
		right: 3%;
	}
	@media only screen and (device-width: 768px) {
		bottom: 15%;
		right: 21%;
	}
	/* different techniques for iPad screening */
	@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: portrait) {
		bottom: 8%;
		right: 11%;
	}
	@media only screen and (min-device-width: 481px) and (max-device-width: 1024px) and (orientation: landscape) {
		/* For landscape layouts only */
		bottom: 15%;
		right: 21%;
	}
}
</style>



// WEBPACK FOOTER //
// src/views/landing/empleador/membresia.vue